<template>
    <button :class="customClasses" class="fill-button" v-once>
		<svg ref="svgel" class="btn_svg" version="1.1" viewBox="0 0 30 25" preserveAspectRatio="none">
			<rect rx="25" ry="25" class="btn_svg_shape" width="30" height="25"/>
		</svg>
        <span class="content"><slot></slot></span>
    </button>
</template>


<script>

export default {
	name: 'button-vue',
	props: {
		type : String,
		hasIcon: {
			type: Boolean,
			default: true
		},
		bold: {
			type: Boolean,
			default: false
		},
		outlined: {
			type: Boolean,
			default: false
		},
		link: {
			type: Boolean,
			default: false
		},
		noBorder: {
			type: Boolean,
			default: false
		},
		uppercase: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		customClasses(){
			let custom = [];
			if(this.type) custom.push(this.type);
			if(this.noBorder) custom.push('no-border');
			if(this.bold) custom.push('bold');
			if(!this.outlined) custom.push('filled');
			if(this.uppercase) custom.push('uppercase');
			if(this.link) custom.push('link');
			if(this.hasIcon ){
				custom.push('has-icon');
			}
			return custom.splice(' ')
		},
	},
	mounted(){
		const VM = this;
		jQuery(document).ready(function($){
			const $svgEl = $(VM.$refs.svgel)
			if($svgEl && $svgEl[0]){
				let
					width = $svgEl.outerWidth(),
					height = $svgEl.outerHeight(),

					$rect = $svgEl.find('rect'),
					totalPerimeter = width*2+height*2;
					$svgEl[0].setAttribute('viewBox', '0 0 '+width+' '+height);
					$rect.attr('width', width);
					$rect.attr('height', height);
					$rect.css({ 
						strokeDashoffset: totalPerimeter,
						strokeDasharray: totalPerimeter
					});
			}
			
		});
	},
	methods: {
		
	}
	
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
/* Stroke animation. Use ems to scale :) */
@keyframes pencil{
  0% {
    stroke-width: 10px;
  }
  75% {
    stroke-width: 7px;
  }
  100%{
    stroke-width: 3px;
  }
}


.fill-button {
	border: none;
	box-shadow: none;
	color: $dark;
	cursor: pointer;
  	@include fluid-type($smallResText, $wideResText, 16px, 22px);
	font-weight: 600;
	text-transform: uppercase;
	padding: 13px 25px;
	position: relative;
	text-decoration: none;
	line-height: 1;
	background-color: transparent;
	will-change: color;
	z-index: 0;
	&:before {
		content: "";
		display: block;
		position: absolute;
		top: 0px;
		bottom: 0px;
		border-radius: 25px;
		left: 0px;
		right: 0px;
		border: 2px solid $yellow;
		opacity: 1;
		@include transition(border, 250ms, 'ease-in-out', 0ms);
	}
	
	> span.content {
		@include transition(color);
		position: relative;
	}
	&.venue-btn{
		padding-right: 25px !important;
		&:hover{
			.icon svg{
				path{
					fill: $dark !important;
				}
			}
		}
		.icon{
			line-height: 0;
			right: 0 !important;
			svg{
				width: 25px;
				height: 25px;
				@include mquery($phone){
					width: 15px;
					height: 15px;		
				}
			}	
		}
	}
	&.has-icon{
		.content{
			display: flex;
			align-items: center;
			svg{
				margin-left: 15px;
			}
		}
	}
	.icon{
		margin-left: 15px;
		position: relative;
    	z-index: 5;
		svg{
			//@include transition(transform);
			width: 10px;
			height: 15px;
			@include mquery($phone){
				width: 10px * 0.75;
				height: 15px * 0.75;	
			}
		}
		path{
			fill: $yellow;
		}
	}
	.btn_svg {
		position: absolute;
		top: 0;
		left: 0;
		border-radius: 25px;
		width: 100%;
		height: 100%;
	}
	.btn_svg_shape {
		stroke: $yellow;
		border-radius: 25px;
		stroke-width: 2px;
		stroke-linecap: round;
		fill: transparent;
	}
	&:hover, &.hover {
		transition-delay: 250ms;
		color: $dark;
		&:before {
			//opacity: 0;
			border-color: $yellow;
			@include transition(border, 250ms, 'ease-in-out', 500ms);
		}
		
		.btn_svg_shape {
			@include transition('stroke-dasharray, stroke-dashoffset', 500ms);
			transition-property: stroke-dasharray, stroke-dashoffset;
			stroke-dashoffset: 0 !important;
			animation: 500ms pencil ease-in forwards;
		}
		.icon svg{
			transform: translateX(5px);
		}
	}
	
	&.green{
		&:before {
			border: 2px solid $green;
		}
		.icon{
			path{
				fill: $green;
			}
		}
		.btn_svg_shape {
			stroke: $green;
		}
	}
	&.white{
		color: #fff;
		&:before {
			border: 2px solid #fff;
		}
		.icon{
			path{
				fill: $dark;
			}
		}
		.btn_svg_shape {
			stroke: $dark;
		}
	}
	&.blue{
		&:before {
			border: 2px solid $blue;
		}
		.icon{
			path{
				fill: $blue;
			}
		}
		.btn_svg_shape {
			stroke: $blue;
		}
	}
	&.red{
		color: $red;
		&:before {
			border: 2px solid $red;
		}
		.icon{
			path{
				fill: $red;
			}
		}
		.btn_svg_shape {
			stroke: $red;
		}
	}
	&.dark, &.gray{
		&:before {
			border: 2px solid $dark;
		}
		.icon{
			path{
				fill: $dark;
			}
		}
		.btn_svg_shape {
			stroke: $dark;
		}
	}
	&.filled{
		.icon{
			path{
				fill: $dark;
				@include transition('fill');
			}
		}
		&:before {
			@include transition('background' , 250ms, 'ease-in-out', 0ms);
			transition-property: border, background;
			background-color: $yellow;
		}
		&:hover, &.hover{
			&:before {
				background-color: #fff;
			}	
			.icon{
				path{
					fill: #fff;
					@include transition('fill');
				}
			}
		}
		&.green{
			&:before {
				background-color: $green;
			}
			&:hover, &.hover{
				&:before {
					background-color: #fff;
				}
				.icon{
					path{
						fill: $green;
					}
				}
			}
		}
		&.white{
			.content{
				color: $dark;
			}
			&:before {
				background-color: #fff;
			}
			&:hover, &.hover{
				.content{
					//color: #fff;
				}
				&:before {
					background-color: $green;
					border: 2px solid $dark;
				}
				.icon{
					path{
						fill: $dark;
					}
				}
			}
		}
		&.blue{
			&:before {
				background-color: $blue;
			}
			&:hover, &.hover{
				&:before {
					background-color: #fff;
				}	
				.icon{
					path{
						fill: $blue;
					}
				}
			}
		}
		&.red{
			.content{
				color: #fff;
			}
			&:before {
				background-color: $red;
			}
			.icon{
				path{
					fill: #fff;
				}
			}
			&:hover, &.hover{
				.content{
					color: $dark;
				}
				&:before {
					background-color: #fff;
				}
				.icon{
					path{
						fill: $red;
					}
				}
			}
		}
		&.dark, &.gray{
			.icon{
				path{
					fill: #fff;
				}
			}
			.content{
				color: #fff;
			}
			&:before {
				background-color: $dark;
			}
			&:hover, &.hover{
				.content{
					color: $dark;
				}
				.icon{
					path{
						fill: $dark;
					}
				}
				&:before {
					background-color: #fff;
				}	
			}
		}
	}
	&.link{
		padding: 0;
		a{
			display: block;
			color: inherit !important;
			text-decoration: none !important;
			position: relative;
			width: 100%;
			text-align: left;
			z-index: 5;
			padding: 13px 25px;
			@include mquery($tablet){
				padding: 12px 20px;
			}
			@include mquery($phone){
				padding: 10px 16px;
			}
		}
		&.has-icon{
			a{
				padding-right: 45px;
				@include mquery($tablet){
					padding-right: 35px;
				}
				@include mquery($phone){
					padding-right: 25px;
				}	
			}
			
		}
		.icon{
			position: absolute;
			top: 50%;
			right: 20px;
			transform: translateY(-50%);
			@include mquery($tablet){
				right: 15px;
			}
			@include mquery($phone){
				right: 10px;
			}
		}
	}
	
	&.uppercase{
		text-transform: uppercase;
	}
	&.bold{
		font-weight: 700;
	}
	&.no-border{
		&:before{
			border: none;
		}
	}
	@include mquery($tablet){
		padding: 12px 20px;
	}
	@include mquery($phone){
		padding: 10px 16px;
	}
}

</style>